var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;


//////////////////
// WEBPACK FOOTER
// ./~/string-convert/camel2hyphen.js
// module id = 1623
// module chunks = 0